import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfiguration } from './i-configuration';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  applicationConfiguration: IAppConfiguration

  constructor(private http: HttpClient) {
    console.log("In ConfigurationService ... ");
  }

  load() {
    const cacheBusterParam = (new Date()).getTime();
    const jsonFile = `assets/config/config.${environment.name}.json`;
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise()
        .then((response: IAppConfiguration) => {
          this.applicationConfiguration = <IAppConfiguration>response;
          resolve();
        }).catch((response: any) => {
          reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
        });
    });
  }

}
